import {
  Briefcase,
  Building,
  Building2,
  Cog,
  Factory,
  HardHat,
  Home,
  Landmark,
  Tractor,
  type LucideIcon,
} from 'lucide-react';
import type { AudienceMeta } from '@shared/constants/audiences';

/**
 * Mapping unique iconName → composant Lucide.
 *
 * Centralise ce mapping pour éviter la duplication dans les 4 composants
 * `Header`, `Footer`, `AudienceDropdown`, `AudienceModal` qui chacun maintenaient
 * leur propre version (au moins une oubliait `tractor` pour Agriculteurs).
 *
 * À étendre ici uniquement si on ajoute un nouvel `iconName` au type
 * `AudienceMeta['iconName']`.
 */
export const AUDIENCE_ICON_MAP: Record<AudienceMeta['iconName'], LucideIcon> = {
  home: Home,
  'building-2': Building2,
  factory: Factory,
  landmark: Landmark,
  building: Building,
  'hard-hat': HardHat,
  tractor: Tractor,
  briefcase: Briefcase,
  cog: Cog,
};

export function getAudienceIcon(meta: AudienceMeta): LucideIcon {
  return AUDIENCE_ICON_MAP[meta.iconName];
}

/**
 * Classes utilitaires Tailwind par tone d'audience.
 * Centralisées pour cohérence visuelle inter-composants.
 */
export const AUDIENCE_TONE_BG: Record<AudienceMeta['tone'], string> = {
  brand: 'bg-brand-50 text-brand-700',
  lavender: 'bg-lavender-50 text-lavender-700',
  sage: 'bg-sage-100 text-sage-500',
  'lavender-700': 'bg-lavender-50 text-lavender-800',
  'brand-700': 'bg-brand-50 text-brand-800',
  accent: 'bg-accent-50 text-accent-800',
};

export const AUDIENCE_TONE_CHIP: Record<AudienceMeta['tone'], string> = {
  brand: 'bg-brand-50 text-brand-800 ring-brand-200/60',
  lavender: 'bg-lavender-50 text-lavender-800 ring-lavender-200/60',
  sage: 'bg-sage-100 text-sage-700 ring-sage-200/60',
  'lavender-700': 'bg-lavender-50 text-lavender-800 ring-lavender-300/60',
  'brand-700': 'bg-brand-50 text-brand-800 ring-brand-300/60',
  accent: 'bg-accent-50 text-accent-800 ring-accent-200/60',
};

export const AUDIENCE_TONE_DOT: Record<AudienceMeta['tone'], string> = {
  brand: 'bg-brand-500',
  lavender: 'bg-lavender-500',
  sage: 'bg-sage-500',
  'lavender-700': 'bg-lavender-700',
  'brand-700': 'bg-brand-700',
  accent: 'bg-accent-500',
};
